import { useState } from "react";
import { PageLayout } from "../components/PageLayout.js";
import { AiUsageDashboard } from "../components/AiUsageDashboard.js";
import { McpUsagePanel } from "../components/McpUsagePanel.js";
import { KnowledgeUsePanel } from "../components/KnowledgeUsePanel.js";

type AiUsageTab = "mcp" | "knowledge" | "internal";

// ADR-0206 §4.1: MCP usage first and the default. No client product name in a
// label — any MCP client reaches the same tools. Knowledge use sits beside it:
// the same door, read for what was served and skipped. Tabs switch in place;
// the URL does not change.
const TABS: ReadonlyArray<{ key: AiUsageTab; label: string }> = [
  { key: "mcp", label: "MCP usage" },
  { key: "knowledge", label: "Knowledge use" },
  { key: "internal", label: "Internal usage" },
];

export function TenantAdminAiUsage() {
  const [tab, setTab] = useState<AiUsageTab>("mcp");
  return (
    <PageLayout
      title="AI usage"
    >
      <div style={{ display: "grid", gap: 12 }}>
        <div className="tabs" role="tablist">
          {TABS.map((t) => (
            <button
              key={t.key}
              type="button"
              role="tab"
              aria-selected={tab === t.key}
              className={`tab${tab === t.key ? " tabActive" : ""}`}
              onClick={() => setTab(t.key)}
            >
              {t.label}
            </button>
          ))}
        </div>
        {tab === "mcp" ? (
          <McpUsagePanel />
        ) : tab === "knowledge" ? (
          <KnowledgeUsePanel />
        ) : (
          <AiUsageDashboard hideIntro usagePath="/api/tenant/ai/usage" logPath="/api/tenant/ai/usage/log" />
        )}
      </div>
    </PageLayout>
  );
}
